<script setup>
import { ref } from "vue";
import { RouterLink, useRoute } from "vue-router";

const isNavOpen = ref(true);
const route = useRoute();

function toggleNav() {
    isNavOpen.value = !isNavOpen.value;
}

const navItems = [
    //{ name: 'Dashboard', path: '/therapist/dashboard', icon: '📊' },
    //{ name: 'Calendar', path: '/therapist/calendar', icon: '📅' },
];
</script>

<template>
  <div class="min-h-screen flex">
    <!-- Navigation -->
    <nav
      class="bg-[rgb(62,68,78)] shadow-lg transition-all duration-300 flex flex-col"
      :class="isNavOpen ? 'w-64' : 'w-14'"
    >
      <!-- Logo/Home -->
      <div class="border-b flex justify-between items-center">
        <RouterLink v-if="isNavOpen" to="/admin" class="flex items-center space-x-2">
          <img src="@/assets/logo_full.svg" class="w-32" alt="Logo" />
          <p class="text-xs text-gray-500">(admin mode)</p>
        </RouterLink>
        <button @click="toggleNav" class="text-gray-500 hover:text-gray-700 h-8">
          {{ isNavOpen ? '◀' : '▶' }}
        </button>
      </div>

      <!-- Nav Items -->
      <div>
        <RouterLink
          v-for="item in navItems"
          :key="item.path"
          :to="item.path"
          class="flex items-center px-4 py-2 hover:bg-[rgb(82,88,98)]"
          :class="route.path === item.path ? 'bg-[rgb(82,88,98)]' : ''"
        >
          <span class="text-xl">{{ item.icon }}</span>
          <span v-if="isNavOpen" class="ml-3 uppercase font-mono font-semibold text-lg text-gray-200">{{ item.name }}</span>
        </RouterLink>
      </div>
    </nav>

    <!-- Main Content -->
    <div class="flex-1">
      <!-- Header -->
      <header class="bg-[rgb(0,201,208)] shadow-md">
        <div class="max-w-7xl mx-auto px-4 py-4">
          <h1 class="text-2xl font-bold text-white">
            {{ route.meta.title || 'Admin Portal' }}
          </h1>
        </div>
      </header>

      <!-- Page Content -->
      <main class="max-w-7xl mx-auto px-4 py-6">
        <RouterView />
      </main>
    </div>
  </div>
</template>
